<template>
  <div class="box">
    <Header :active="active" />
    <Banner />
    <div class="list">
      <div class="inner">
        <!-- <div style="margin-bottom: 20px">
          首页><span class="titles">大儒工作坊</span>
        </div> -->
        <div class="forlist clearfix">
          <div class="publictitle">
            <p class="pli">大儒工作坊</p>
            <!-- <p class="pli1">Daru Workshop</p> -->
          </div>

          <div
            @click="goJob(item)"
            v-for="(item, index) in list"
            :key="index"
            class="for"
          >
            <img :src="item.cover" alt="" />
            <div class="ri">
              <div class="item jus">
                <span class="tit">{{ item.title }}</span>
                <span class="time">{{ item.fabuTime }}</span>
              </div>
              <div class="content">{{ item.summary }}</div>
            </div>
          </div>
        </div>
        <div class="pages">
          <el-pagination
            @current-change="loadData"
            layout="prev, pager, next"
            :page-count="size"
            :current-page="page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Map ref="map" />
    <Foot />
    <Right />
  </div>
</template>

<script>
import Right from "../components/Right.vue";
import Header from "../components/header.vue";
import Map from "../components/map.vue";
import Banner from "../components/banner.vue";
export default {
  components: {
    Header,
    Map,
    Right,
    Banner,
  },
  data() {
    return {
      active: 4,
      page: 1,
      size: 1,
      list: [],
    };
  },
  computed: {},
  mounted() {
    this.getList();
  },
  beforeDestroy() {
    this.$refs.map.destroy();
  },
  methods: {
    getList() {
      var data = {
        limit: 10,
        page: this.page,
        type: 3,
      };
      this.$get("/web/api/list_article", data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.size = res.data.size;
          this.list = res.data.list;
        }
      });
    },
    loadData(e) {
      this.page = e;
      this.getList();
    },
    goJob(item) {
      sessionStorage.setItem("job", JSON.stringify(item));
      this.$router.push(`/jobInner`);
    },
  },
};
</script>

<style  scoped>
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.six {
  padding: 50px 0;
  background-color: #eff9f8;
}
.seven {
  padding: 50px 0;
}
.imglist img {
  display: block;
  width: 230px;
  height: 107px;
  margin-right: 20px;
  float: left;
  margin-bottom: 20px;
}
.imglist > img:nth-child(5n) {
  margin-right: 0;
}
.foot {
  line-height: 50px;
  background-color: #898989;
  text-align: center;
  color: #fff;
}
.list {
  padding: 25px 0 50px 0;
}
.titles {
  color: #2c87ce;
}
.liucheng {
  display: block;
  width: 1020px;
  margin: 0 auto;
}

.pages {
  display: flex;
  justify-content: center;
}
.for {
  cursor: pointer;
  padding: 20px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  margin-bottom: 30px;
  box-shadow: -6px 0 10px #e8e7eb, /*左边阴影*/ 6px 0 10px #e8e7eb,
    /*右边阴影*/ 0 0px 10px #e8e7eb, /*顶部阴影*/ 0 6px 40px #e8e7eb;
  /*底边阴影*/
}
.for img {
  display: block;
  width: 170px;
  height: 105px;
  border-radius: 16px;
  flex-shrink: 0;
}
.ri {
  width: 970px;
}
.jus {
  justify-content: space-between;
}
.tit {
  color: #4d4e53;
  font-size: 18px;
}
.time {
  color: #868686;
  font-size: 14px;
}
.content {
  margin-top: 10px;
  color: #a7a7a7;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>